<form *ngIf="env.USE_TAILWIND" [formGroup]="loginForm" (ngSubmit)="login()" ridangoFocusInvalidInput>
    <mat-form-field class="full-width text-primary" appearance="outline">
        <mat-label>{{ 'PH_PERSONAL_CODE' | translate }}</mat-label>
        <input
            matInput
            ridangoInput
            formControlName="personalCode"
            aria-label="{{ 'PH_PERSONAL_CODE' | translate }}"
            title="{{ 'PH_PERSONAL_CODE' | translate }}"
            type="text"
            required
            ridangoUntouchOnFocusout />

        <mat-error *ngIf="personalCode.touched && personalCode.errors?.['required']">
            {{ 'LOCAL_INPUT_PERSONAL_CODE_MISSING' | translate }}
        </mat-error>
        <mat-error *ngIf="personalCode.touched && personalCode.errors?.['personalCode']">
            {{ 'LOCAL_INPUT_PERSONAL_CODE_WRONG_FORMAT' | translate }}
        </mat-error>
    </mat-form-field>

    <mat-form-field class="full-width mb-5" appearance="outline">
        <mat-label>{{ 'PH_PHONE' | translate }}</mat-label>
        <input
            matInput
            ridangoInput
            formControlName="phoneNumber"
            required
            ridangoUntouchOnFocusout
            aria-label="{{ 'PH_PHONE' | translate }}"
            title="{{ 'PH_PHONE' | translate }}" />

        <mat-error *ngIf="phoneNumber.touched && phoneNumber.errors?.['required']">
            {{ 'LOCAL_INPUT_PHONE_NUMBER_MISSING' | translate }}
        </mat-error>
    </mat-form-field>

    <div class="mb-16 flex items-center lg:mb-5">
        <button
            class="btn-secondary tartu-light-dark:rounded-lg tartu-light:shadow-md mr-16 w-32 lg:w-64"
            tabindex="0"
            type="submit">
            {{ 'BTN_LOG_IN' | translate }}
        </button>
    </div>

    <p class="text-center md:text-left">
        {{ 'REGISTER_DONT_HAVE_ACCOUNT' | translate }}
        <a class="link" [routerLink]="'/register' | localize">
            {{ 'LOG_INTO_CREATE_AN_ACCOUNT_LINK' | translate }}
        </a>
    </p>
</form>
